<script setup lang="ts">
import type CommonHeader from '@/components/common/Header/Header.vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'

const header = ref<InstanceType<typeof CommonHeader> | null>()
const layout = ref<HTMLElement | null>(null)
let resizeObserver: ResizeObserver | null = null

// Fonction pour définir la hauteur du header
const setHeaderHeight = (height: string) => {
  if (layout.value) {
    layout.value.style.setProperty('--header-height', height)
  }
}

// Logique pour mettre à jour la taille du header
const updateHeaderSize = () => {
  const headerHeight = header.value?.headerElement?.header?.offsetHeight || 128
  setHeaderHeight(`${headerHeight}px`)
}

const setHeaderSize = () => {
  resizeObserver = new ResizeObserver(updateHeaderSize)

  if (header.value?.headerElement?.header) {
    resizeObserver.observe(header.value.headerElement.header)
    updateHeaderSize() // Met à jour la taille immédiatement
  } else {
    setHeaderHeight('128px') // Valeur par défaut
  }
}

onMounted(() => {
  setHeaderSize()
})

onBeforeUnmount(() => {
  if (resizeObserver && header.value?.headerElement?.header) {
    resizeObserver.unobserve(header.value.headerElement.header)
    resizeObserver.disconnect()
  }
})
</script>

<template>
  <div
    ref="layout"
    class="default-layout"
  >
    <common-header ref="header" />
    <main
      id="main-content"
      role="main"
    >
      <slot />
    </main>
    <common-footer />
  </div>
</template>

<style scoped>
/* Layout top offset based on Header height */
.default-layout {
  --header-height: 148px;
  padding-top: var(--header-height);
}

@media (min-width: 768px) {
  .default-layout {
    --header-height: 130px;
  }
}

main {
  position: relative;
}
</style>
